import React from "react";
import ProfilePage from "../../components/ProfilePage/ProfilePage";

const Profile: React.FC = () => {
  return (
    <div>
      <ProfilePage />
    </div>
  );
};

export default Profile;
